@if (isLoading) {
  <div class='loading-spinner' style="position:relative; z-index: 9;"></div>
}
@if (!isLoading) {
  <div class="mmc-overview-documents-container flex-wrap">
    @if (marketingDocuments?.length > 0) {
      <div class="mmc-documents-left-container">
        @for (document of marketingDocuments; track document; let index = $index) {
          @if (index < 3) {
            <div  class="mmc-marketing-item">
              <span (click)="openMarketingDocument(document)"><img [src]="getImageIcon(document)"><a
              class="nav-link-text">{{document.title}}</a></span>
            </div>
          }
        }
      </div>
    }
    @if (marketingDocuments?.length > 3) {
      <div class="mmc-documents-right-container">
        @for (document of marketingDocuments; track document; let index = $index) {
          @if (index >= 3) {
            <div  class="mmc-marketing-item">
              <span (click)="openMarketingDocument(document)"><img [src]="getImageIcon(document)"><a class="nav-link-text">{{document.title}}</a></span>
            </div>
          }
        }
      </div>
    }
    @if (isModelProvider) {
      <div class="overview-info"> Provide links and any updates for marketing materials directly to Schwab administer. </div>
    }
    @if (marketingDocuments?.length ===0) {
      <div class="mmc-overview-documents-container-no-rows">
        No documents available.
      </div>
    }
  </div>
}
@if (!isLoading) {
  <form id="informaForm" method="POST" [action]="samlActionURL" target="_blank" >
    <input type="hidden" name="SAMLResponse" [value]="samlResponse"/>
  </form>
}
